var React = require('react');

function Share (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.25 13.25a.75.75 0 0 0 1.5 0V4.636l2.955 3.129a.75.75 0 0 0 1.09-1.03l-4.25-4.5a.75.75 0 0 0-1.09 0l-4.25 4.5a.75.75 0 1 0 1.09 1.03L9.25 4.636v8.614Z","key":0}),React.createElement("path",{"d":"M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z","key":1})]);
}

Share.defaultProps = {"viewBox":"0 0 20 20","fill":"currentColor","className":"w-5 h-5"};

module.exports = Share;

Share.default = Share;
